module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9e6fa02c90bda1a6681d729d805de953.png";